export const MODULE_NAME = 'template';
export const ACCESS_NAME = 'Template';
